import 'isomorphic-unfetch';

import { makeQueryString } from './makeQueryString';

// import Router from 'next/router';

const dev = process.env.NODE_ENV !== 'production';

// think how to block bots

export default async function sendRequestAndGetResponse(path, opts: any = {}) {
  const headers = Object.assign(
    {},
    opts.headers || {},
    opts.externalServer
      ? {}
      : {
          connection: 'keep-alive',
          'Content-type': 'application/json; charset=UTF-8',
          'x-wib-signature': process.env.NEXT_PUBLIC_WIB_KEY,
          'x-wib-is-server': typeof window === 'undefined' ? '1' : '0',
        },
  );

  const qs = (opts.qs && `?${makeQueryString(opts.qs)}`) || '';

  // console.log('header', headers['x-forwarded-for']);

  // modify, remove
  const response = await fetch(
    opts.externalServer
      ? `${path}${qs}`
      : `${
          dev ? process.env.NEXT_PUBLIC_URL_WIB : process.env.NEXT_PUBLIC_PRODUCTION_URL_WIB
        }${path}${qs}`,
    Object.assign(
      { method: 'POST', credentials: opts.externalServer ? 'include' : 'same-origin' },
      opts,
      { headers },
    ),
  );

  // console.log(response.status);
  // console.log(response.statusText);

  const text = await response.text();

  if (response.status >= 400) {
    console.error(text);
    throw new Error(text);
  }

  try {
    const data = JSON.parse(text);

    // console.log(data);

    return data;
  } catch (err) {
    if (err instanceof SyntaxError) {
      return text;
    }

    throw err + 'test';
  }
}
